export class SurveyPermissionModel {
    topic: TopicModel;
    countries: string;
}

export class TopicModel {
    topicKey: string;
    topicName: string;
}